import { Flex, Image } from "@chakra-ui/react";
// import bgIcon from "../../assets/aimon/banner-bg.png";
import mainIcon from "../../assets/aimon/banner-main.png";
import styles from "./Banner.module.scss";

export default function Banner() {
  // const isMobile = window.innerWidth < 768;
  return (
    <Flex className={styles.container} id="home">
      {/* <Image src={bgIcon} alt="logo" className={styles.bg} /> */}

      <video
        src="/bg.mp4"
        autoPlay
        playsInline
        loop
        muted
        className={styles.bgVideo}
      />
      <Flex className={styles.mainGroup}>
        <Image src={mainIcon} alt="logo" className={styles.mainLogo} />

        <Flex className={styles.mainTxt}>
          AIMon is an AI-driven, blockchain-integrated metaverse where players
          collect, train, and evolve unique virtual creatures.
        </Flex>

        <Flex className={styles.mainBtn}>Enter Metaverse</Flex>
      </Flex>
    </Flex>
  );
}
